import { Users, Scale, Mic, Zap } from "lucide-react";
import { Reveal } from "../components/Reveal";

const ITEMS = [
  { icon: Users, text: "Atendimento direto com as sócias" },
  { icon: Scale, text: "Atuação consultiva e contenciosa" },
  { icon: Mic, text: "Palestras, treinamentos e apoio a escritórios" },
  { icon: Zap, text: "Resposta rápida e acompanhamento próximo" },
];

export const CredibilityStrip = () => (
  <section className="bg-brown-dark border-y border-brown-dark" data-testid="credibility-strip">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 divide-cream/15 lg:divide-x">
      {ITEMS.map((item, i) => (
        <Reveal key={item.text} delay={i * 0.08} className="py-8 px-2 lg:px-6 flex items-start gap-3">
          <item.icon size={18} className="text-cream/70 shrink-0 mt-0.5" />
          <span
            className="text-sm text-cream/85 leading-snug"
            data-testid={`credibility-item-${i}`}
          >
            {item.text}
          </span>
        </Reveal>
      ))}
    </div>
  </section>
);
